var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgYoutubeFooter = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#75777B",
    d: "m10.406 9.69 4.08 2.319-4.08 2.318zM21.6 4.457v15.086a2.058 2.058 0 0 1-2.057 2.057H4.457A2.058 2.058 0 0 1 2.4 19.543V4.457c0-1.136.92-2.057 2.057-2.057h15.086c1.136 0 2.057.921 2.057 2.057m-1.8 7.556s0-2.555-.326-3.78a1.956 1.956 0 0 0-1.38-1.389c-1.213-.33-6.094-.33-6.094-.33s-4.882 0-6.094.33c-.673.18-1.2.712-1.38 1.389-.326 1.221-.326 3.78-.326 3.78s0 2.554.326 3.78c.18.677.707 1.187 1.38 1.367 1.212.326 6.094.326 6.094.326s4.881 0 6.094-.33c.673-.18 1.2-.69 1.38-1.367.326-1.222.326-3.776.326-3.776"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgYoutubeFooter);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/youtube-footer.bbb2f9e84736582b08a1c6675b98cd9d.svg";